import React from "react";

import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

import { SpainFlag, UnitedStatesFlag } from "./flags";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(1)
  },
  selected: {
    fontWeight: "bold",
    textDecoration: "underline"
  },
  unselected: {
    opacity: 0.5
  },
  flag: {
    width: 20,
    height: 14,
    borderRadius: 2,
    boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.2)"
  }
}));

const LANGUAGES = [
  { locale: "en", label: "English", Flag: UnitedStatesFlag },
  { locale: "es", label: "Español", Flag: SpainFlag }
];

const LanguageSwitch = ({ locale, onChange }) => {
  const classes = useStyles();
  return (
    <div className={classes.root} role="group" aria-label="Language / Idioma">
      {LANGUAGES.map(({ locale: value, label, Flag }) => (
        <Button
          key={value}
          size="small"
          lang={value}
          aria-pressed={locale === value}
          className={
            locale === value ? classes.selected : classes.unselected
          }
          startIcon={<Flag className={classes.flag} />}
          onClick={() => onChange(value)}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};

export default LanguageSwitch;
